import { Logo } from "@/components/brand/Logo";
import { useI18n } from "@/i18n/I18nProvider";

export const FullScreenLoader = () => {
  const { t } = useI18n();
  return (
    <div data-testid="app-loader" className="flex min-h-[100dvh] flex-col items-center justify-center gap-6 bg-[#F8FAFC]">
      <Logo size="lg" testId="loader-logo" />
      <div className="h-1 w-32 overflow-hidden rounded-full bg-[#E5E7EB]">
        <div className="loader-bar h-full w-1/3 rounded-full bg-[#FEB601]" />
      </div>
      <p className="text-sm text-gray-500">{t("app.loading")}</p>
    </div>
  );
};
